module.exports = __webpack_public_path__ + "media/cloud.0dc16c00.wav";